import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

class CheckIn {
  getAll = async () => {
    const response = await axios
      .get<any>(`${API_URL}check-in-history`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.checkIn;
  };
}

export default new CheckIn();
